import React, { FC, useEffect } from 'react'
import SidePanelFramework from '@bt-react/components/SidePanelFramework'
import List from '@bt-react/components/List'
import { IconType } from '@bt-react/components/Icon'
import { ParticipantsPanelProps } from './types'
import username from '../../lib/username'
import get from 'lodash/get'
import classnames from 'classnames'
import style from './ParticipantsPanel.module.scss'
import { ParticipantInformationInterface } from '../../dataStore/reducers/docs/syncUi/types'
import TalksPresenterControls from '../TalksPresenterControls'

const ParticipantsPanel: FC<ParticipantsPanelProps> = props => {

  const existsInSeatingOrder = (participant: string): boolean => {

    return props.seatingOrder.includes(username.getPureUsername(participant))

  }

  const getParticipantName = (participantInformation?: ParticipantInformationInterface): string =>
    participantInformation ? `${get(participantInformation, 'firstName', '')} ${get(participantInformation, 'lastName', '')}` : ''

  const getParticipantCompany = (participantInformation?: ParticipantInformationInterface): string =>
    participantInformation ? get(participantInformation, 'companyName', '') : ''


  const renderPresenters = ({ presenters, debug = false, identity }: ParticipantsPanelProps): React.JSX.Element[] =>
    presenters
      .filter( presenter => debug ? true : existsInSeatingOrder(presenter.BTID))
      .map((presenter, i) => {

      const presenterClasses = classnames(
        style['participant-panel-content'], {
          [style['participant-panel--missing']]: debug && !existsInSeatingOrder(presenter.BTID)
        }
      )

      return <div
        key={`presenter-item-${presenter}`}
        className={presenterClasses}
        data-bdd={`presenter-entry`} >
        <span
          className={style['participant-panel-content__participant-info']}
        >
          <div data-bdd='presenter-entry-name'>{ getParticipantName(presenter) }</div>
          <div data-bdd='presenter-entry-company'>{ getParticipantCompany(presenter) }</div>
        </span>
        <div
          data-bdd={`presenter-entry-controls`}
          className={style['participant-panel-controls']}
        >
          { presenter &&
            <TalksPresenterControls
              participant={presenter}
              dataBdd={`presenter-entry-control-panel`}
            />
          }
        </div>
      </div>

    })

  const renderObservers = ({ observers }): React.JSX.Element[] => {

    return observers.map((observer: ParticipantInformationInterface, i: number) =>
      <div
        data-bdd={`observer-entry`}
        className={style['participant-panel-observer']}
        key={`observer-item-${observer}`}>
          <span
          className={style['participant-panel-content__participant-info']}
          >
            <div data-bdd='observer-entry-name'>{ getParticipantName(observer)}</div>
            <div data-bdd='observer-entry-company'>{ getParticipantCompany(observer) }</div>
        </span>
      </div>
    )

  }

  const formatTitle = (header: string, subheader: string) => <div><span className={style['participant-panel-section-header']}>{ header } </span><span className={style['participant-panel-section-subheader']}>{ subheader }</span></div>

  const checkForMissingUser = () => props.addMissingUserToParticipantsDetails()

  useEffect(() => {
    checkForMissingUser()
  }, [props.participantInformation])

  return <SidePanelFramework
    icon={IconType.iconName.userCog}
    title='Presenter controls'
    dataBdd='side-panel-participants'
    contentPadding={false}
    content={
      <div>
        <List
          content={props.presenters.length > 0 ? renderPresenters(props) : undefined}
          size={'large'}
          header={{
            title: formatTitle(`Presenters`, `(up to ${props.maxPresenters})`),
            icon: IconType.iconName.user
          }}
          color={IconType.colour.neutral}
        />
        <List
          content={props.observers.length > 0 ? renderObservers(props) : undefined}
          size={'large'}
          header={{
            title: formatTitle('Observers', '(up to 10)'),
            icon: IconType.iconName.eye
          }}
          color={IconType.colour.lightGrey}
        />
        { props.debug &&
        <div data-bdd='debug-message'
             className={style['padding']} >
          *Debug: Presenters in <span className={style['participant-panel--missing']}>
            orange
          </span> are not in the seating order.
        </div> }
      </div>
    }
  />

}

export default ParticipantsPanel
